module.exports = __webpack_public_path__ + "static/img2-c9b6ffed4046fc179207a212114000da.svg";